import config from "config";
import { isAbsoluteUrl } from "utils/url";
import { ALLOWED_KTB_HOSTS } from "constants/URL";
import { timeoutPromise } from "utils/promise";

const generateBaseUrl = (url) => {
  if (isAbsoluteUrl(url)) {
    const ktbUrl = new URL(url);

    return ALLOWED_KTB_HOSTS.indexOf(ktbUrl.host) > -1 && ktbUrl;
  }
  const baseUrl = window && window.location && window.location.origin;

  return new URL(url, baseUrl);
};

class KeywordTriggeredBannerClient {
  constructor({ timeout = 2000 } = {}) {
    this.bannerUrl = generateBaseUrl(config.keywordTriggeredBanner.baseUrl);
    this.timeout = timeout;
  }

  getBannerUrl(term) {
    const queryParameters = `${config.keywordTriggeredBanner.queryParameter}=${term}`;
    let queryUrl = new URL(this.bannerUrl);

    if (!queryUrl) {
      console.error("The configured Banner URL is invalid");
      return;
    }

    queryUrl.search = queryParameters;

    return queryUrl;
  }

  fetchBanner(term) {
    const resolveData = (response) => {
      if (response.ok) {
        return response.text();
      }

      return Promise.reject(Error("Error fetching Banner"));
    };
    const headers = {
      method: "GET",
      mode: "cors",
    };

    const url = this.getBannerUrl(term);

    if (!url) {
      return Promise.reject();
    }

    return timeoutPromise(this.timeout, fetch(url.href, headers))
      .then(resolveData)
      .then((result) => Promise.resolve(result))
      .catch((e) => console.error(e));
  }
}

const ktbClient = new KeywordTriggeredBannerClient({
  timeout: config.backend.timeout,
});

export const fetchBanner = (term) => {
  return ktbClient.fetchBanner(term);
};
